import { render, staticRenderFns } from "./CultureEdit.vue?vue&type=template&id=764114d6&scoped=true&"
import script from "./CultureEdit.vue?vue&type=script&lang=js&"
export * from "./CultureEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764114d6",
  null
  
)

export default component.exports